import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class IdentityWorkgroupsService {

  constructor(private http: HttpClient) { }

  async getWorkgroups(organisation: string) {
    return this.http.get(environment.identityUrl + "/api/organisations/" + organisation + "/workgroups");
  }

  async getWorkgroup(organisation: string, workGroupId: string) {
    return this.http.get(environment.identityUrl + "/api/organisations/" + organisation + "/workgroups/" + workGroupId + "");
  }

  async deleteWorkgroup(organisation: string, workGroupId: string) {
    return this.http.delete(environment.identityUrl + "/api/organisations/" + organisation + "/workgroups/" + workGroupId + "");
  }

  async createWorkgroup(organisation: string, name: string) {
    return this.http.post(environment.identityUrl + "/api/organisations/" + organisation + "/workgroups", {"Name": name, "organisationGuid": organisation})
  }

  async editWorkgroup(organisation: string, workGroupId: string, name: string) {
    return this.http.put(environment.identityUrl + "/api/organisations/" + organisation + "/workgroups/" + workGroupId + "", {"Name": name, "organisationGuid": organisation})
  }

  async deleteMemberWorkgroup(organisation: string, workGroupId: string, userId: string){
    return this.http.delete(environment.identityUrl + "/api/organisations/" + organisation + "/workgroups/" + workGroupId + "/deleteWorkgroupMember/" + userId + "");
  }

  async updateMembersWorkgroup(organisation: string, workGroupId: string, workgroupMembers: any){
    return this.http.put(environment.identityUrl + "/api/organisations/" + organisation + "/workgroups/" + workGroupId + "/updateWorkgroupMembers", workgroupMembers);
  }

  async addMemberToWorkgroup(organisation: string, workgroupId: string, workgroupMember: any) {
    return this.http.post(environment.identityUrl + "/api/organisations/" + organisation + "/workgroups/" + workgroupId + "/addWorkgroupMember", workgroupMember)
  }
  async checkAllowWorkgroupDelete(organisation: string, workgroupId: string){
    return this.http.get(environment.apiUrl + "/organisations/" + organisation + "/AllowWorkgroupDelete/" + workgroupId + "");
  }
}
